(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["s6-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('s6-delivery-estimate')) return;

    class S6DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section, dialog');
        if (this.scope) this.scope.addEventListener('variant:update', this.onVariantUpdate);
      }

      disconnectedCallback() {
        if (this.scope) this.scope.removeEventListener('variant:update', this.onVariantUpdate);
      }

      onVariantUpdate = (event) => {
        const data = event.detail && event.detail.data;
        if (!data || !data.html) return;
        if (data.newProduct) {
          this.dataset.productId = data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
          return;
        }
        const next = data.html.querySelector('s6-delivery-estimate');
        if (next) this.innerHTML = next.innerHTML;
      };
    }

    customElements.define('s6-delivery-estimate', S6DeliveryEstimate);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["s6-product-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const clean = (html) => html.replace(/\\\\n/g, '').replace(/\\n/g, '');
    const load = (root) => {
      if (!root.dataset.s6pdUrl || root.dataset.s6pdReady) return;
      root.dataset.s6pdReady = 'true';
      fetch(root.dataset.s6pdUrl + '.js')
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          if (product && product.description) root.innerHTML = clean(product.description);
        })
        .catch(() => {});
    };
    const scan = (scope) => scope.querySelectorAll('.s6pd').forEach(load);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
